module.exports = __webpack_public_path__ + "static/media/claim_it.feed410e.png";